import { TableRow } from "@mui/material";
import dayjs from "dayjs";
import { FilterType } from "../../../configs/filterTypes";
import { SortType } from "../../../configs/sortTypes";
import { ProductQuantityTracking } from "../../../data/entities";
import { StyledTableCell } from "../../../shared/components/CustomTable/Styled";
import TableView from "../../../shared/components/TableView";
import { StyledNavLinkNewTab } from "../../../shared/styled/TableStyles";

const TABLE_COLUMNS = [
    { text: "Mã sản phẩm", icon: <></> },
    { text: "Tên sản phẩm", icon: <></> },
    { text: "Kho", icon: <></> },
    { text: "Số lượng tồn đầu", icon: <></> },
    { text: "Số lượng nhập kho", icon: <></> },
    { text: "Số lượng xuất kho", icon: <></> },
    { text: "Số lượng tồn cuối", icon: <></> },
];


const ProductQuantityTrackingSortTypes: SortType[] = [
    {
        field: "name",
        text: "Tên từ A-Z",
        isReversed: true,
    },
    {
        field: "name",
        text: "Tên từ Z-A",
    },
    {
        field: "start_quantity",
        text: "Tồn đầu tăng dần",
        isReversed: true,
    },
    {
        field: "start_quantity",
        text: "Tồn đầu giảm dần",
    },
];

const ProductQuantityTrackingFilterType: FilterType[] = [
    {
        field: "start_date",
        options: [],
        text: "Từ ngày",
        title: "Ngày bắt đầu",
        type: "date",
    },
    {
        field: "end_date",
        options: [],
        text: "Đến ngày",
        title: "Ngày kết thúc",
        type: "date",
    },
    {
        field: "storage",
        options: [
            {
                text: "Kho 1",
                value: "Kho 1",
            },
            {
                text: "Kho 2",
                value: "Kho 2",
            },
        ],
        text: "Tất cả kho",
        title: "Kho",
    },
    {
        field: "category",
        options: [
            {
                text: "Phuy",
                value: "Phuy",
            },
            {
                text: "Thùng",
                value: "Thùng",
            },
            {
                text: "Cơ Khí Ô Tô",
                value: "Cơ Khí Ô Tô",
            },
        ],
        text: "Tất cả danh mục",
        title: "Danh mục",
    },
    {
        field: "category_group",
        options: [],
        text: "Tất cả nhóm sản phẩm",
        title: "Nhóm sản phẩm",
        type: "category_group",
    },
];

export const ProductQuantityTrackingRow = ({ item }: { item: ProductQuantityTracking }) => (
    <TableRow>
        <StyledTableCell align="left">
            <StyledNavLinkNewTab
                href={`/products/${item.id}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {item.product_code?.trim() ? item.product_code : item.id}
            </StyledNavLinkNewTab>
        </StyledTableCell>
        <StyledTableCell align="left">{item.name}</StyledTableCell>
        <StyledTableCell align="left">{item.storage}</StyledTableCell>
        <StyledTableCell align="left">{item.start_quantity ?? "-"}</StyledTableCell>
        <StyledTableCell align="left">{item.total_imported ?? "-"}</StyledTableCell>
        <StyledTableCell align="left">{item.total_exported ?? "-"}</StyledTableCell>
        <StyledTableCell align="left">{item.end_quantity ?? "-"}</StyledTableCell>
    </TableRow>
);

// TODO1: Review filter types
const ProductQuantityTrackingTab = () => (
    <TableView
        url="/products/quantity-tracking/"
        filterTypes={ProductQuantityTrackingFilterType}
        sortTypes={ProductQuantityTrackingSortTypes}
        rowElement={ProductQuantityTrackingRow}
        tableColumns={TABLE_COLUMNS}
        defaultFilterParams={{
            start_date: dayjs().startOf("year").format("YYYY-MM-DD"), // Get first day of the year
            end_date: dayjs().format("YYYY-MM-DD"),
        }}
        textString="Tìm kiếm theo Mã sản phẩm, tên sản phẩm"
    />
);

export default ProductQuantityTrackingTab;
